"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getTabIndex = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _debounce2 = _interopRequireDefault(require("../debounce"));
var _isClient = _interopRequireDefault(require("../isClient"));
var getTabIndex = function getTabIndex(disabled) {
  return !disabled && typeof window !== 'undefined' && window.matchMedia('(min-width: 564px)').matches ? 0 : -1;
};
exports.getTabIndex = getTabIndex;
var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    disabled = _ref.disabled;
  var _useState = (0, _react.useState)(getTabIndex(disabled)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  if ((0, _isClient["default"])()) {
    (0, _react.useEffect)(function () {
      var _debounce = (0, _debounce2["default"])(function () {
          setTabIndex(getTabIndex(disabled));
        }),
        invoke = _debounce.invoke,
        clear = _debounce.clear;
      window.addEventListener('resize', invoke);
      return function cleanup() {
        window.removeEventListener('resize', invoke);
        clear();
      };
    });
  }
  return {
    tabIndex: tabIndex
  };
};
exports["default"] = _default;